import { Section, Wrapper } from 'components/base';
import PropTypes from 'prop-types';
import React from 'react';
import WindowIcon from 'svgs/elements/browser.svg';
import Deco1 from 'svgs/elements/deco-1.svg';
import Deco2 from 'svgs/elements/deco-2.svg';
import Deco3 from 'svgs/elements/deco-3.svg';
import { deco1, deco2, deco3, root, windowIcon } from './Video.module.scss';

const Video = ({ padding, theme, wrapper, data }) => (
  <Section padding={padding} theme={theme} style={{ position: 'relative' }}>
    <Deco1 className={deco1} /><Deco2 className={deco2} /><Deco3 className={deco3} />
    <Wrapper size={wrapper}>
      <div className={root}>
        <WindowIcon className={windowIcon} />
        <hr/>
        <img src={data.publicURL} alt="拖放式 no-code 編輯器" />
      </div>
    </Wrapper>
  </Section>
);

Video.propTypes = {
  data: PropTypes.object.isRequired,
  theme: PropTypes.string,
  wrapper: PropTypes.string,
  padding: PropTypes.string,
};

export default Video;